export const packageList = [
  {
    name: 'kyemap',
    activeRule: ['kyemap', 'gis'],
  },
]

export const remoteModuleConfig = {
  dev: ['kyemap'],
  stg: ['kyemap'],
  uat: ['kyemap'],
  prd: ['kyemap'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/map/index.js